import React from 'react'
import { useStateContext } from '../context/StateContext'

export default function ChildTable() {
  const [state] = useStateContext()

  let url = `/content/ccorg/us/en.bmi-childscale.png`

  if (process.env.NODE_ENV === 'development') {
    url = `http://localhost:4502/content/ccorg/us/en.bmi-childscale.png`
  }

  const { gender, age, height, weight } = state

  const feet = Math.floor(height / 12)
  const inches = height - feet * 12

  url += `?gender=${gender}&years=${age}&feet=${feet}&inches=${inches}&pounds=${weight}`

  return (
    <div>
      <img className="child-table" src={url} alt="child table" />
    </div>
  )
}
